import React, { memo, useMemo } from 'react';
import { useEngineInstance } from '@surveycake/react-logic-engine';
import { useSurveyConfig } from 'app/core/survey-config';
import ReCAPTCHA from './ReCAPTCHA';
import Submit from './Submit';
import { useStyles } from './styles';

function SubmitContainer() {
  const engine = useEngineInstance();
  const { multiplePages, reCaptcha } = useMemo(() => {
    const data = engine.getSurveyData();
    return {
      multiplePages: data.multiplePages,
      reCaptcha: data.re_captcha
    };
  }, [engine]);
  const { wording } = useSurveyConfig();
  const styles = useStyles([multiplePages]);

  return (
    <div className={styles.submitContainer} aria-label="submit">
      {multiplePages && (
        <div className={styles.info}>{wording.common.info.finished}</div>
      )}
      {reCaptcha && <ReCAPTCHA />}
      <Submit />
    </div>
  );
}

export default memo(SubmitContainer);
